import * as React from "react";
import { SVGProps } from "react";
const SvgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 28V4h8v7a1 1 0 0 0 1 1h7v16H8ZM18 5.414 22.586 10H18V5.414Zm7.707 4.879-8-8A.996.996 0 0 0 17 2H7a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V11a.999.999 0 0 0-.206-.608l-.087-.099ZM10 16h12v-2H10v2Zm0 4h12v-2H10v2Zm0 4h5v-2h-5v2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFile;
